<template>
<div>
	<Form :label-width="110">
		<Row :gutter="10">
			<Col span="6">
				<FormItem label="参保公司">
					<Input v-model="params.companyName" clearable @on-enter="search" placeholder="参保公司名称"></Input>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="生成日期">
					<daterange @on-change="val=>{setDateRange(val,'createTime')}" is-fulltime placeholder="请选择生成日期" placement="bottom-end"></daterange>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="结算状态">
					<Select v-model="params.status" placeholder="请选择结算状态" clearable >
						<Option value="WAIT_DONE">待结算</Option>
						<Option value="WAIT_CONFIRM">结算待确认</Option>
						<Option value="OK_DONE">已结算</Option>
					</Select>
				</FormItem>
			</Col>
			<Col span="6">
				<FormItem label="结算类型">
					<Select v-model="params.settlementType" placeholder="请选择结算类型" clearable >
						<Option value="POLICY">投保</Option>
						<Option value="ENDORSE">保全</Option> 
					</Select>
				</FormItem>
			</Col>
			

		</Row>
		<Row :gutter="10">
			<Col span="24" class="right">
				<Button type="info" @click="search">搜索</Button>
				<Button type="primary" @click="excel">导出</Button>
			</Col>
		</Row>
	</Form>
	<p class="totalM">
		结算保费合计：{{total}}元 
	</p>
	<i-table :columns="columns" url="/guarantee/queryMyStatements.json" :params="params" ref="table" @on-selection-change="selectChange">
		<template slot-scope="{ row, index }" slot="attachmentUrl">
			<a :href="row.attachmentUrl" v-if="row.attachmentUrl" target="_blank">查看</a>
		</template>
		<template slot-scope="{ row, index }" slot="action">
			<a 
				@click="openUpload(row)" 
				v-if="row.status=='WAIT_DONE'||row.status=='WAIT_CONFIRM'">
				{{row.status=='WAIT_DONE'?'上传结算单':'重新上传结算单'}}
			</a>
			<br v-if="row.status=='WAIT_DONE'||row.status=='WAIT_CONFIRM'">
			<a @click="toDetail(row)">查看明细</a>
		</template>
		
	</i-table>
	<Modal v-model="editShow" :title="modalTitle" :mask-closable="false" >
		<Form :label-width="110" :model="editForm" ref="editForm">
			<Form-item label="结算单" >
				<UploadFileImg @on-success="uploadSuccess" type="select" btn-text="上传"/> 
				<a @click="openOriginFile(editForm.attachmentUrl)" v-show="editForm.attachmentUrl" class="ml15">查看</a>
			</Form-item>
		</Form>
		<div slot="footer" style="text-align: center">
			<Button @click="editShow = false" type="default">取消</Button>
			<Button @click="confirmUpload" :disabled="Boolean(!editForm.attachmentUrl)" type="primary">确定</Button>
		</div>
	</Modal>
</div>
</template>

<script>
import ITable from '@/components/common/ITable'
import daterange from '@/components/common/daterange'
import UploadFileImg from '@/components/common/UploadFileImg'

export default {
	components:{daterange,ITable,UploadFileImg},
	data () {
		return {
			params:{
				productCode:'JIN_KONG'
			},
			columns:[
				{title: '参保公司',key: 'companyName',minWidth:200},
				{title: '参保机构',key: 'deptName',minWidth:200},
				{title: '所属平台',key: 'platformNameShow',minWidth:200},
				{title: '联系人',key: 'userName',width:130},
				{title: '员工总数',key: 'userSize',width:100},
				{title: '结算保费（元）',key: 'premiumAmount',width:140},
				{title: '结算状态',key: 'statusName',width:120},
				{title: '结算类型',key: 'settlementTypeShow',minWidth:200},
				{title: '生成时间',key: 'createTime',width:180},
				{title: '上传结算单时间',key: 'uploadTime',width:180},
				{title: '结算时间',key: 'settlementTime',width:180},
				{title: '结算单',slot: 'attachmentUrl',width:80},
				{title: '操作',slot: 'action',width:140},
			],
			total:'',
			editForm:{},
			editShow:false,
			selectedList:[],
			modalTitle:''
		}
	},
	created () {
		this.getTotal();
	},
	methods: {
		// 获取总计
		getTotal(){
			this.$axios.post("/guarantee/queryEndBillPremium.json",this.params).then(res=>{
				this.total=res
			})
		},
		search () {
			this.$refs.table.getList();
			this.getTotal();
		},
		excel () {
			this.exportToExcel("/guarantee/exportEndBill",this.params);
		},
		setDateRange (val,key) {
			this.params[key+"Begin"] = val[0];
			this.params[key+"End"] = val[1];
		},
		toDetail(row){
			window.open('/haierProduct.html#/jinkong/settle-detail/'+row.id)
		},
		// 打开上传结算单
		openUpload(row){
			if(row=='multipleUpload'){
				// 批量上传
				if(this.selectedList.length==0){
					return this.alert('至少选择一项待结算的数据')
				}
				let selectItem=this.selectedList.find(item=>{
					return item.status!='WAIT_DONE'
				})
				if(selectItem){
					return this.alert('只能选择待结算的数据')
				}
				this.editForm={
					ids:this.selectedList.map(item=>{
						return item.id
					})
				}
				this.modalTitle='批量结算'
			}else if(row=='multipleResetUpload'){
				// 批量重新上传
				if(this.selectedList.length==0){
					return this.alert('至少选择一项结算待确认的数据')
				}
				let selectItem=this.selectedList.find(item=>{
					return item.status!='WAIT_CONFIRM'
				})
				if(selectItem){
					return this.alert('只能选择结算待确认的数据')
				}
				this.editForm={
					ids:this.selectedList.map(item=>{
						return item.id
					})
				}
				this.modalTitle='重新批量上传结算单'
			}else{
				this.editForm={
					ids:[row.id]
				}
				this.modalTitle=row.status=='WAIT_DONE'?'上传结算单':'重新上传结算单'
			}
			this.editShow=true;
		},
		// 确定上传
		confirmUpload(){
			this.$axios.post('/guarantee/uploadStatements.json',{
				ids:this.editForm.ids,
				attachmentUrl:this.editForm.attachmentUrl
			}).then(res=>{
				this.search()
				this.editShow=false;
				this.toast('操作成功')
			});
		},
		uploadSuccess(val){
			this.$set(this.editForm,'attachmentUrl',val.url)
		},
		selectChange(val){
			this.selectedList=val
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/jinkong/list/SettlementList.vue